import axios from 'axios'
// import Cookies from 'js-cookie'
import * as types from '../mutation-types'

// empty event hack
const emptyHack = [{ start: '1900-01-01' }]
const bookingColor = {
	new: 'warning',
	confirmed: 'primary',
	completed: 'success',
	canceled: 'error'
}

// state
export const state = {
	date: new Date().toISOString().substr(0, 10),
	month: new Date().toISOString().substr(0, 7),
	bookings: emptyHack,
	showCancelled: false,
	anyFreeSlot: false,
	beginSlot: 0,
	endSlot: 0
}

// getters
export const getters = {
	date: state => state.date,
	month: state => state.month,
	bookings: state => state.bookings,
	showCancelled: state => state.showCancelled,
	anyFreeSlot: state => state.anyFreeSlot,
	beginSlot: state => state.beginSlot,
	endSlot: state => state.endSlot
}

// mutations
export const mutations = {
	[types.SAVE_DATE](state, date) {
		state.date = date
	},
	[types.SAVE_MONTH](state, month) {
		state.month = month
	},
	[types.SAVE_BOOKINGS](state, bookings) {
		state.bookings = bookings
	},
	[types.REMOVE_BOOKINGS](state) {
		state.bookings = emptyHack
	},
	[types.UPDATE_BOOKING](state, booking) {
		state.bookings.forEach(item => {
			if (item.bookingId === booking.id) {
				item.booking = booking
				item.color = bookingColor[booking.state]
			}
		})
	},
	[types.SET_SHOW_CANCELED](state, showCancelled) {
		state.showCancelled = showCancelled
	},
	[types.SET_ANY_FREE_SLOT](state, anyFreeSlot) {
		state.anyFreeSlot = anyFreeSlot
	},
	[types.SET_BEGIN_SLOT](state, beginSlot) {
		state.beginSlot = beginSlot
	},
	[types.SET_END_SLOT](state, endSlot) {
		state.endSlot = endSlot
	}
}

// actions
export const actions = {
	async getBookings({ commit, state }) {
		let bookings = []
		let { data } = await axios.get(`bookings/day/${state.date}`)

		data.data.forEach(booking => {
			let show = booking.state === 'canceled' ? state.showCancelled : true

			if (show) {
				bookings.push({
					start: `${booking.book_dt} ${booking.begin_time}`,
					end: `${booking.book_dt} ${booking.end_time}`,
					color: bookingColor[booking.state],
					bookingId: booking.id,
					booking: booking
				})
			}
		})

		if (bookings.length === 0) {
			commit(types.REMOVE_BOOKINGS)
			commit(types.SET_ANY_FREE_SLOT, data.anyFreeSlot)
			commit(types.SET_BEGIN_SLOT, 0)
			commit(types.SET_END_SLOT, 0)
		} else {
			commit(types.SAVE_BOOKINGS, bookings)
			commit(types.SET_ANY_FREE_SLOT, data.anyFreeSlot)
			commit(types.SET_BEGIN_SLOT, data.beginSlot)
			commit(types.SET_END_SLOT, data.endSlot)
		}
	}
}
